import { useQuery } from '@tanstack/react-query';
import { fetchAnalytics } from '@/utils/analyticsAPI';
import type { AnalyticsRequest, AnalyticsResponse } from '@/components/reports/graphs/types';

export function useAnalytics(config: AnalyticsRequest | null) {
  return useQuery<AnalyticsResponse, Error>({
    queryKey: ['analytics', config],
    queryFn: () => {
      if (!config) {
        throw new Error('Configuration required');
      }
      return fetchAnalytics(config);
    },
    enabled: !!config && config.periods.length > 0,
    staleTime: 5 * 60 * 1000,  // 5 minutes (following existing pattern)
    cacheTime: 30 * 60 * 1000, // 30 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
}
